/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { BaseSettingsService } from '../../providers/base-settings.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FooterComponent
  ],
  exports: [
    FooterComponent
  ],
  providers: [
    BaseSettingsService
  ]
})
export class FooterModule { }
